import React, { useEffect, useState } from "react";
import { use } from "react";
import { fetchChargesApi } from "../../ApiCalls/Charges";
import { USER_URL } from "../../constant/api";
import { useAuth } from "../../context/AuthContext";

const SellerCharges = () => {
  const dummyData = [
    {
      slNo: 1,
      date: "2025-01-15",
      documentId: "DOC12345",
      serviceDescription: "Revenue 1",
      status: "Pending",
      serviceCharges: 500,
      totalAmount: 1500,
      action: "Pay",
    },
    {
      slNo: 2,
      date: "2025-01-16",
      documentId: "DOC12346",
      serviceDescription: "Revenue 2",
      status: "Processing",
      serviceCharges: 300,
      totalAmount: 800,
      action: "Paid",
    },
    {
      slNo: 3,
      date: "2025-01-17",
      documentId: "DOC12347",
      serviceDescription: "Banner Amount",
      status: "Failed",
      serviceCharges: 200,
      totalAmount: 600,
      action: "Pay",
    },
    {
      slNo: 4,
      date: "2025-01-18",
      documentId: "DOC12348",
      serviceDescription: "Offer Amount",
      status: "Successful",
      serviceCharges: 400,
      totalAmount: 1000,
      action: "Paid",
    },
    {
      slNo: 5,
      date: "2025-01-19",
      documentId: "DOC12349",
      serviceDescription: "Sponsor Amount",
      status: "Pending",
      serviceCharges: 250,
      totalAmount: 750,
      action: "Pay",
    },
    {
      slNo: 6,
      date: "2025-01-20",
      documentId: "DOC12350",
      serviceDescription: "Revenue 1",
      status: "Processing",
      serviceCharges: 600,
      totalAmount: 1600,
      action: "Paid",
    },
    {
      slNo: 7,
      date: "2025-01-21",
      documentId: "DOC12351",
      serviceDescription: "Revenue 2",
      status: "Failed",
      serviceCharges: 350,
      totalAmount: 950,
      action: "Pay",
    },
    {
      slNo: 8,
      date: "2025-01-22",
      documentId: "DOC12352",
      serviceDescription: "Banner Amount",
      status: "Successful",
      serviceCharges: 450,
      totalAmount: 1250,
      action: "Paid",
    },
    {
      slNo: 9,
      date: "2025-01-23",
      documentId: "DOC12353",
      serviceDescription: "Offer Amount",
      status: "Pending",
      serviceCharges: 300,
      totalAmount: 900,
      action: "Pay",
    },
    {
      slNo: 10,
      date: "2025-01-24",
      documentId: "DOC12354",
      serviceDescription: "Sponsor Amount",
      status: "Processing",
      serviceCharges: 550,
      totalAmount: 1350,
      action: "Paid",
    },
    {
      slNo: 11,
      date: "2025-01-25",
      documentId: "DOC12355",
      serviceDescription: "Revenue 1",
      status: "Failed",
      serviceCharges: 400,
      totalAmount: 1200,
      action: "Pay",
    },
    {
      slNo: 12,
      date: "2025-01-26",
      documentId: "DOC12356",
      serviceDescription: "Revenue 2",
      status: "Successful",
      serviceCharges: 500,
      totalAmount: 1500,
      action: "Paid",
    },
    {
      slNo: 13,
      date: "2025-01-27",
      documentId: "DOC12357",
      serviceDescription: "Banner Amount",
      status: "Pending",
      serviceCharges: 250,
      totalAmount: 750,
      action: "Pay",
    },
    {
      slNo: 14,
      date: "2025-01-28",
      documentId: "DOC12358",
      serviceDescription: "Offer Amount",
      status: "Processing",
      serviceCharges: 350,
      totalAmount: 1050,
      action: "Paid",
    },
    {
      slNo: 15,
      date: "2025-01-29",
      documentId: "DOC12359",
      serviceDescription: "Sponsor Amount",
      status: "Failed",
      serviceCharges: 450,
      totalAmount: 1250,
      action: "Pay",
    },
  ];

  const [charges, setCharges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [popup, setPopup] = useState({
    visible: false,
    success: false,
    button: false,
    message: "",
    subMessage: "",
    showCloseIcon: false,
    Trybutton: false,
  });
  const { user } = useAuth();

  useEffect(() => {
    const fetchCharge = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetchChargesApi();
        console.log("charges", response.data);
        setCharges(response.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
        console.log("error in fetch charges", error);
      }
    };
    fetchCharge();
  }, []);

  const payNow = async (type, id) => {
    try {
      const data = {
        payment_for: type, // sponsored, banner, special_offer
        object_id: id,
      };
      const res = await USER_URL.post(
        "/orders/seller/promotion/razorpay/initiate/",
        data,
      );
      const { razorpay_order_id, amount } = res.data.payment;
      const { razorpay_key } = res.data;
      const customerOrderNumber = res.data.customer_order_number;
      // console.log(" Razorpay Order ID:", customerOrderNumber);

      console.log(" INIT RESPONSE", res.data);

      const options = {
        key: razorpay_key,
        currency: "INR",
        amount: amount,
        order_id: razorpay_order_id,
        name: "BricksnMix",
        description: "Service Payment",
        image: "/images/logo/icon_sg.png",
        handler: async function (response) {
          console.log("Payment Response:", response);
          const confirmData = {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
            // customer_order_number: customerOrderNumber,
          };
          console.log("💳 Payment Confirmation Data:", confirmData);

          const verify = await USER_URL.patch(
            "/orders/seller/promotion/razorpay/confirm/",
            confirmData,
          );
          console.log(" Payment Verification:", verify.data);
          if (verify.data.Status === "1") {
            setPopup({
              visible: true,
              success: true,
              button: true,
              showCloseIcon: false,
              message: "Payment Successful",
              // subMessage: "Order Placed Successfully",
            });
          } else {
            // setPopup({
            //   visible: true,
            //   success: false,
            //   // button: true,
            //   showCloseIcon: false,
            //   message: "Payment Failed",
            //   subMessage: "Please try again",
            //   Trybutton: true,
            // });
            alert("Payment Failed");
          }
        },
        prefill: {
          name: user?.user_name || "User name",
          email: user?.email || "user@gmail.com",
          contact: "9999999999",
        },
        theme: {
          color: "#F37254",
        },
        modal: {
          ondismiss: function () {
            console.log(" Razorpay popup closed");
          },
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (err) {
      console.error(" Error in payNow:", err);
      // setPopup({
      //   visible: true,
      //   success: false,
      //   // button: true,
      //   showCloseIcon: false,
      //   message: "Payment Failed",
      //   subMessage: "Please try again",
      //   Trybutton: true,
      // });
    }
  };

  return (
    <div className="h-full w-full">
      {/* Fixed header */}

      <div className="w-full bg-white">
        <div className="">
          <div className="flex flex-wrap items-center gap-6 border-b bg-white pb-5">
            <button className="rounded-md border border-brand-primary px-3 py-1">
              All
            </button>
            <input
              type="date"
              className="rounded-md border border-brand-primary px-3 py-1"
            />
            <input
              type="date"
              className="rounded-md border border-brand-primary px-3 py-1"
            />
            <button className="rounded-md border border-brand-primary px-3 py-1">
              Revenue 1
            </button>
            <button className="rounded-md border border-brand-primary px-3 py-1">
              Revenue 2
            </button>
            <button className="rounded-md border border-brand-primary px-3 py-1">
              Banner Amount
            </button>
            <button className="rounded-md border border-brand-primary px-3 py-1">
              Offer Amount
            </button>
            <button className="rounded-md border border-brand-primary px-3 py-1">
              Sponsor Amount
            </button>
          </div>
          {/* Header */}
          <div className="grid w-full grid-cols-[4rem,2fr,2fr,2.5fr,2.5fr,2.5fr,2.5fr,2fr] bg-white p-2 font-medium text-brand-button-green-bg">
            <div className="text-center">Sl No</div>
            <div className="text-center">Date</div>
            <div className="text-center">Document ID</div>
            <div className="text-center">Service Description</div>
            <div className="text-center">Status</div>
            <div className="text-center">Service Charges</div>
            <div className="text-center">Total Amount</div>
            <div className="text-center">Actions</div>
          </div>
        </div>
      </div>

      {/* Content below the header */}
      <div className="">
        {/* Rows */}
        {charges.map((item, index) => (
          <div
            key={index}
            className="grid grid-cols-[4rem,2fr,2fr,2.5fr,2.5fr,2.5fr,2.5fr,2fr] items-center gap-2 p-2"
          >
            <div className="rounded border p-2 text-center">{index + 1}</div>
            <div className="rounded border p-2 text-center">{item.date}</div>
            <div className="rounded border p-2 text-center">
              {item.documentId}
            </div>
            <div className="rounded border p-2 text-center">{item.type}</div>
            <div className="rounded border p-2 text-center">{item.status}</div>
            <div className="rounded border p-2 text-center">
              {item.serviceCharges}
            </div>
            <div className="rounded border p-2 text-center">
              {item.totalAmount}
            </div>
            <div className="text-center">
              {/* <button
                className={`rounded-md px-3 py-1 ${
                  item.action === "Pay"
                    ? "border border-green-500 bg-green-100 text-green-700"
                    : "border border-gray-300 bg-gray-100 text-gray-500"
                }`}
              >
                {item.action}
              </button> */}
              <button onClick={()=>payNow(item.type,item.id)}>pay</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SellerCharges;
